import * as XLSX from 'xlsx';
import { message } from 'antd';
import { formatExcelDate } from '../utils/excelFileParser';
import { useDispatch, useSelector } from 'react-redux';
import { setData } from '../store/actions/rsoImportActions';
import { useCallback } from 'react';
import moment from 'moment';

export const useExcelDataLoader = (setLoadingFileUpload) => {
  const dispatch = useDispatch();

  const { file } = useSelector((state) => state.rsoImportStore);

  const handleFileUpload = useCallback(
    (headerRow, startRow) => {
      if (!file) {
        message.error('Файл не выбран', 3);
        return;
      }

      typeof setLoadingFileUpload === 'function' && setLoadingFileUpload(true);

      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const ab = e.target.result;
          const workbook = XLSX.read(ab, { type: 'array', cellDates: true });
          const sheet = workbook.Sheets[workbook.SheetNames[0]];

          const jsonData = XLSX.utils.sheet_to_json(sheet, {
            header: 1,
            raw: true,
          });
          const headerIndex = parseInt(headerRow, 10) - 1;
          const dataStartIndex = parseInt(startRow, 10) - 1;

          if (
            headerIndex >= 0 &&
            headerIndex < jsonData.length &&
            dataStartIndex >= 0
          ) {
            const rawHeader = jsonData[headerIndex];

            const validColumns = rawHeader
              .map((col, index) => {
                if (col instanceof Date) {
                  return {
                    col: moment(col).format('DD.MM.YYYY HH:mm:ss'),
                    index,
                  };
                }

                return {
                  col,
                  index,
                };
              })
              .filter(
                ({ col }) => col !== undefined && col !== null && col !== ''
              );

            const tableData = [];
            let emptyRowStreak = 0;

            for (let i = dataStartIndex; i < jsonData.length; i++) {
              const row = jsonData[i];

              const isEmpty =
                !row ||
                row.every(
                  (cell) => cell === undefined || cell === null || cell === ''
                );
              if (isEmpty) {
                emptyRowStreak++;
                if (emptyRowStreak >= 3) break;
                continue;
              }

              emptyRowStreak = 0;

              const rowData = {};
              validColumns.forEach(({ col, index }) => {
                let value = row[index];
                if (
                  typeof col === 'string' &&
                  col.toLowerCase().includes('дата')
                ) {
                  value = formatExcelDate(value);
                }
                rowData[col] = value;
              });

              tableData.push(rowData);
            }

            dispatch(setData(tableData));
            window.scrollTo({
              top: 500,
              behavior: 'smooth',
            });
          } else {
            message.error(
              'Неверный номер строки заголовка или начала данных',
              3
            );
          }
        } catch (err) {
          console.error('Ошибка при загрузке файла:', err);
          message.error('Произошла ошибка при обработке файла', 3);
        } finally {
          typeof setLoadingFileUpload === 'function' &&
            setLoadingFileUpload(false);
        }
      };

      reader.readAsArrayBuffer(file);
    },
    [dispatch, file, setLoadingFileUpload]
  );

  return handleFileUpload;
};
